import { useFormContext } from 'react-hook-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { teamsService } from '../../../../../app/services/teamsService'
import { TeamParams } from '../../../../../app/services/teamsService/createTeam'
import { useToast } from '../../../../components/ui/use-toast'
import { FormCreateTeamData } from '../../TeamsPage/useTeamsController'
import { useEffect, useState } from 'react'

export const useTeamAddController = () => {
  const [open, setOpen] = useState(false)
  const methods = useFormContext<FormCreateTeamData>()
  const queryClient = useQueryClient()

  const teamName = methods.watch('name')
  useEffect(() => {
    if (teamName)
      methods.reset({
        code: teamName
          .replace(/\s+/g, '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-zA-Z\d]/g, '')
          .toLowerCase(),
      })
  }, [teamName])

  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['createTeam'],
    mutationFn: async (data: TeamParams) => await teamsService.createTeam(data),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['Allteams', {}],
      })
    },
  })

  const handleAddTeam = async (data: FormCreateTeamData) => {
    try {
      const response = await mutateAsync(data)
      if (response.name === data.name) {
        toast({
          title: 'Equipe criada com sucesso!',
        })
      }
      setOpen(false)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          error?.message ||
          'Ocorreu um erro ao tentar criar a equipe, tente novamente mais tarde.',
      })
    }
  }

  return {
    methods,
    open,
    setOpen,
    handleAddTeam,
    isPending,
  }
}
